import { Grid, Segment, SegmentGroup } from 'semantic-ui-react';
import { TitleSegment } from '@britishcouncil/react-admin';
import { Timestamp } from '@britishcouncil/common-core';

import {
  RHFormCheckbox,
  RHFormDatePicker,
  RHFormInput,
  RHFormSelect,
  useFormContext,
} from 'components';
import { useFollowUpTrainers } from './useFollowUpTrainers';
import { FollowUpFormData } from './followUpValidation';

export const FollowUpForm = () => {
  const { trainerOptions, isLoading: isLoadingTrainers } = useFollowUpTrainers();
  const {
    formMethods: { control, watch },
  } = useFormContext<FollowUpFormData>();

  const isFromIdp = watch('isFromIdp');

  return (
    <SegmentGroup>
      <TitleSegment title="Follow Up" icon="redo" />
      <Segment>
        <Grid columns={4}>
          <Grid.Row>
            <Grid.Column>
              <RHFormDatePicker
                label="Follow Up date"
                control={control}
                name={'followUpDate'}
                toDate={Timestamp.now()}
              />
            </Grid.Column>

            {!isFromIdp && (
              <Grid.Column>
                <RHFormSelect
                  label="Trainer"
                  placeholder="Select a trainer..."
                  options={trainerOptions}
                  name="trainerId"
                  data-testid="follow-up-trainer"
                  control={control}
                  disabled={isLoadingTrainers}
                  loading={isLoadingTrainers}
                  search
                  clearable
                  required
                />
              </Grid.Column>
            )}

            {isFromIdp && (
              <Grid.Column>
                <RHFormInput label="Trainer" name="idpTrainer" control={control} />
              </Grid.Column>
            )}

            <Grid.Column>
              <RHFormCheckbox name="isFromIdp" control={control} label="IDP" />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </SegmentGroup>
  );
};
